import { request } from '@umijs/max';

const itemDefService = {
  getItemDefs: async () => {
    const response = await request<API.Service.ItemDef[]>(
      '/general/item-defs',
      {
        method: 'GET',
        headers: {
          isToken: false,
        },
      },
    );

    return response;
  },

  deleteItemDef: async (id: number) => {
    const response = await request<API.Service.ItemDef[]>(
      `/admin/delete-item?id=${id}`,
      {
        method: 'PUT',
      },
    );

    return response;
  },

  createItemDef: async (itemDef: API.Service.ItemDefForm) => {
    const response = await request('/admin/create-item', {
      method: 'POST',
      data: itemDef,
    });

    return response;
  },

  updateItemDef: async (itemDef: API.Service.ItemDefForm) => {
    const response = await request('/admin/edit-item', {
      method: 'PUT',
      data: itemDef,
    });

    return response;
  },
};

export default itemDefService;
